<template>
  <div
    class="context"
  >
    <div class="header">
      <div class="search">
        <el-page-header @back="back" :content="viewTitle"> </el-page-header>
      </div>
    </div>
    <div class="main_box">
      <div class="form">
        <el-form
          :model="patientForm"
          size="small"
          class="not_bottom_form"
          label-width="150px"
        >
          <div class="msg_title">基本信息</div>
          <el-form-item label="患者姓名">
            <span>{{ patientForm.patient_name }}</span>
          </el-form-item>
          <el-form-item label="性别">
            <span v-if="patientForm.sex == 1">男</span>
            <span v-else>女</span>
          </el-form-item>
          <el-form-item label="手机号">
            <span>{{ patientForm.patient_phone }}</span>
          </el-form-item>
          <el-form-item label="就诊医院">
            <span>{{ patientForm.hospital }}</span>
          </el-form-item>
          <el-form-item label="就诊城市">
            <span>{{ patientForm.province }}/{{ patientForm.city }}</span>
          </el-form-item>
          <el-form-item label="就诊医生">
            <span>{{ patientForm.doctor_name }}</span>
          </el-form-item>
          <el-form-item label="就诊科室">
            <span>{{ patientForm.department }}</span>
          </el-form-item>
          <el-form-item label="上报日期">
            <span>{{ patientForm.submit_date }}</span>
          </el-form-item>
          <el-form-item label="癌种">
            <span>{{ patientForm.tumour }}</span>
          </el-form-item>
          <!-- <el-form-item label="分期（选填）">
            <span>{{ patientForm.stage }}</span>
          </el-form-item>
          <el-form-item label="治疗线数">
            <span>{{ patientForm.line_number }}</span>
          </el-form-item>
          <el-form-item label="治疗方案">
            <span>{{ patientForm.schedule }}</span>
          </el-form-item> -->
          <!-- <div class="msg_title">用药信息</div>
                    <el-form-item label="使用药物">
                        <span>{{ showDrugName(patientForm.drug_code) }}</span>
                    </el-form-item>
                    <el-form-item label="购药记录">
                    </el-form-item>
                    <div>
                        <el-table :data="patientForm.medications" stripe>
                            <el-table-column label="周期" prop="medication_cycle_web" width="60"></el-table-column>
                            <el-table-column label="日期" prop="cycle_date" show-overflow-tooltip></el-table-column>
                            <el-table-column label="支数" prop="medication_count" width="60"></el-table-column>
                            <el-table-column label="类别" prop="medication_type"></el-table-column>
                        </el-table>
                    </div>
                    <el-form-item label="是否脱落">
                        <span v-if="patientForm.is_lose == 1">否</span>
                        <span v-else>是</span>
                    </el-form-item>
                    <el-form-item label="脱落原因" v-if="patientForm.is_lose == 2">
                        <span>{{ patientForm.lose_reason1 }}</span>
                    </el-form-item> -->
        </el-form>
      </div>
      <div class="form form_right">
        <div class="msg_title has_btn_title">
          <span
            >{{ patientForm.patient_name }}，{{
              patientForm.patient_phone
            }}</span
          >
          <span class="btn" @click="copyPhone">复制</span>

          <span class="status_text" v-if="currentMessage.status == 2">已完成</span>
          <!-- <div class="tabs" ref="tabList" @mousewheel="mousewheel">
            <div
              v-for="(item, index) in allTaskData"
              :key="item.task_id"
              class="tab_"
              :class="activeTaskId == item.task_id ? 'active_tab' : ''"
              @click="activeTab(item)"
            >
              {{ allTaskData.length - index }}
              <span>{{ item | statusTitleFilter(self_) }}</span>
            </div>
          </div> -->
        </div>
        <el-form
          :model="messageForm"
          ref="drug_form"
          class="el_form_box"
          size="normal"
          label-width="150px"
          :disabled="disabled"
          :rules="rules"
        >
          <el-form-item label="留言：">
              <span>{{messageForm.message}}</span>
          </el-form-item>
        </el-form>

        <div class="btn_box" v-if="currentMessage.status != 2">
          <div>
            <!-- <el-button @click="lastRow">上一个</el-button> -->
            <el-button @click="submit_audit" type="primary">
              {{ confirmText }}
            </el-button>
            <!-- <el-button @click="nextRow">下一个</el-button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { clone, lcGet, formatTime } from "@/global/utils";
import { getImageUrl } from "@/api/index";
import imgView from "../common/imgView";

const self = this;
export default {
  name: "auditView",
  components: {
    imgView,
  },
  data() {
    return {
      self_: this,
      is_finish: 0,
      confirmText: "完成处理",
      viewTitle: '留言详情',
      disabled: false,
      rules: {},
    };
  },
  computed: {
    ...mapState("illuserData", {
      currentMessage: "currentMessage",
      messages: "messages",
    }),
    patientForm() {
      // console.log(this.currentMessage);
      if (this.currentMessage) {
        return this.currentMessage.patient_data;
      }
      return {};
    },
    messageForm() {
      return clone(this.currentMessage)
    }
  },
  filters: {},
  mounted() {
    // this.task_id = clone(this.audit_visit_id);
    // this.getIllForm(this.task_id);
  },
  beforeDestroy() {},
  methods: {
    back() {
      this.$emit("changeTopTab", "tableView");
    },
    copyPhone(val) {
      let phone = this.patientForm.patient_phone;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(phone);
        this.$message.success("复制成功");
      }
    },
    mousewheel(e) {
      let v = -e.wheelDelta / 2;
      this.$refs.tabList.scrollLeft += v;
      e.preventDefault();
    },
    activeTab(item) {
      console.log("item", item);
    },
    lastRow() {
      let index = this.audit_ill_ids.findIndex((n) => n == this.task_id);
      if (index > 0) {
        let id = this.audit_ill_ids[index - 1];
        this.task_id = clone(id);
        this.getIllForm(id);
        this.$message.success("已进入上一条");
      } else {
        this.$message.warning("已经是第一条了");
      }
    },
    nextRow(type) {
      let index_ = -1;
      this.audit_ill_ids.forEach((v, i) => {
        if (v == this.task_id) {
          index_ = i;
        }
      });
      if (index_ === this.audit_ill_ids.length - 1) {
        this.$message.warning("已经是最后一条了");
        if (type && type === "del") {
          this.goBack();
        } else {
          this.getIllForm(this.task_id);
        }
      } else {
        this.unlockNow();
        setTimeout(() => {
          let id = this.audit_ill_ids[index_ + 1];
          this.task_id = clone(id);
          this.getIllForm(id);
          this.$message.success("已进入下一条");
        }, 0);
      }
    },

    submit_audit() {
      this.httpGet('/vipmessage/finish',{
        message_id: this.currentMessage.message_id
      }).then(res => {
        this.$message.success('留言处理完成');
      })
    },
  },
};
</script>

<style scoped lang="scss">
.context {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background: #fff;

  .header {
    height: 45px;
    line-height: 45px;

    display: flex;
    justify-content: space-between;
    padding: 0 20px;

    .search {
      padding-top: 15px;
    }
  }

  .main_box {
    display: flex;
    height: calc(100% - 50px);
    overflow: hidden;

    .form {
      flex: 1;
      height: 100%;
      overflow: hidden;
      overflow-y: auto;
      padding: 5px;
      box-sizing: border-box;

      .msg_title {
        line-height: 35px;
        font-size: 0.875rem;
        padding: 0 20px;
        background: rgb(233, 233, 235);
        color: #606266;
        margin-bottom: 5px;
      }

      .has_btn_title {
        font-size: 1.25rem;
        font-weight: 600;
        display: flex;

        .btn {
          padding: 0 20px;
          margin-left: 20px;
          color: #409eff;
          cursor: pointer;
          font-size: 0.9rem;
          font-weight: 500;
        }

        .status_text {
          font-size: 0.9rem;
          font-weight: 500;
          color: #67c23a;
          padding: 0 20px;
        }
        .tabs {
          flex: 1;
          overflow-y: hidden;
          overflow-x: auto;
          display: flex;
          &::-webkit-scrollbar {
            display: none;
          }
          .tab_ {
            padding: 0 20px;
            cursor: pointer;
            white-space: nowrap;
            span {
              font-size: 10px;
              font-weight: 100;
            }
          }
          .active_tab {
            background: white;
            border-top: 1px solid #e9e9eb;
          }
        }
      }
    }

    .form_right {
      flex: 2;
      display: flex;
      flex-flow: column;

      .el_form_box {
        flex: 1;
        overflow-y: auto;
      }

      .drug_log_box {
        display: flex;

        .input_span {
          margin-right: 5px;
        }

        .icon_span {
          padding: 0 10px;
          font-size: 24px;
          cursor: pointer;
        }
      }

      .btn_box {
        flex: 0 0 40px;
        width: 100%;
        text-align: center;
        padding: 5px;
        box-sizing: border-box;
        background-color: #fafafa;
      }

      .finish_form {
        .form_form_item {
          position: relative;
          left: -60px;
        }
      }
    }
  }
}
</style>